import { useMemo } from 'react'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'

export const useNoResultsPlaceholderText = () => {
  const isPortal = useIsPortal()
  return useMemo(() => {
    return isPortal ? 'global.main_search_no_results_placeholder_portal' : 'global.main_search_no_results_placeholder'
  }, [isPortal])
}
